import type { CityConfig } from "../city-template/types";

export const athensOhConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Athens County Probate Court", href: "https://www.athenscountyohio.gov/probate-court", description: "Athens County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Athens County Clerk of Courts", href: "https://www.athenscountyohio.gov/clerk-of-courts", description: "Athens County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Athens",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "athens-oh",
  route: "/athens-oh",
  title: "Emergency Passport Athens, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Athens, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Athens County and the Ohio University area including Nelsonville, The Plains, and Albany. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Athens, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Athens and Ohio University area travelers — including Athens County — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Athens%20Ohio%20historic%20college%20town%20with%20Ohio%20University%20campus%20buildings%20and%20red%20brick%20architecture%20along%20the%20Hocking%20River%2C%20charming%20uptown%20district%20with%20local%20shops%20and%20tree-lined%20streets%2C%20warm%20afternoon%20light%20illuminating%20the%20classic%20academic%20atmosphere%2C%20rolling%20Appalachian%20foothills%20in%20the%20background%2C%20American%20college%20town%20atmosphere%20with%20rich%20cultural%20heritage%2C%20professional%20photography%20with%20warm%20golden%20tones&width=1800&height=700&seq=athens-oh-hero-001&orientation=landscape",
  heroImageAlt: "Athens Ohio historic college town with Ohio University campus and red brick architecture",
  geoPosition: "39.3292;-82.1013",
  geoPlacename: "Athens, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 400 miles from Athens via I-70",
  },
  nearbyCitiesZips: [
    { name: "Athens", zips: "45701" },
    { name: "Nelsonville", zips: "45764" },
    { name: "The Plains", zips: "45780" },
    { name: "Albany", zips: "45710" },
    { name: "Chauncey", zips: "45719" },
    { name: "Glouster", zips: "45732" },
    { name: "Trimble", zips: "45782" },
    { name: "Millfield", zips: "45761" },
    { name: "New Marshfield", zips: "45766" },
    { name: "Amesville", zips: "45711" },
    { name: "Coolville", zips: "45723" },
    { name: "Pomeroy", zips: "45769" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Athens departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "OU Campus Coverage", desc: "Serving Athens County and the Ohio University community" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Columbus, OH", route: "/columbus-oh" },
    { name: "Fast passport renewal in Zanesville, OH", route: "/zanesville" },
    { name: "Emergency passport help in Lancaster, OH", route: "/lancaster-oh" },
    { name: "Urgent passport services in Marietta, OH", route: "/marietta" },
    { name: "Same-day passport help in Parkersburg, WV", route: "/cities/parkersburg" },
    { name: "Passport courier services in Cleveland, OH", route: "/cleveland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Athens remotely via secure courier. We do not have a walk-in office in Athens — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Athens County and the Ohio University community.",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  fpcOfficeDistance: "Serving all of Athens County and the surrounding Appalachian region",
  serviceAreaIntro: "From the Ohio University campus in Uptown Athens to the rolling Appalachian foothills of Athens County, from Nelsonville and The Plains to Albany and Glouster — Fast Passport Center serves the entire region. We regularly help students, faculty, and residents from the Appalachian foothills get their passports fast.",
  nearbyCitiesIntro: "We serve all Athens neighborhoods and the surrounding Athens County region including Nelsonville, The Plains, Albany, Chauncey, Glouster, Trimble, Millfield, New Marshfield, Amesville, Coolville, and Pomeroy. If you are anywhere in the Athens area or southeastern Ohio, we have you covered.",
  howItWorksIntro: "Most Athens travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Athens travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Athens and Ohio University area travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Athens? Here are the most common ones we hear from Athens County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Athens international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Emily W.",
      location: "Athens, OH",
      rating: 5,
      text: "As an Ohio University student preparing for a semester abroad in Italy, I needed my passport fast. Fast Passport Center had it ready in 5 days and answered all my questions about traveling as a student.",
      service: "New Passport",
    },
    {
      name: "David C.",
      location: "Nelsonville, OH",
      rating: 5,
      text: "I thought I'd have to drive to Columbus or Charleston for an emergency passport. Fast Passport Center handled everything from right here in Athens County. Got mine in 3 days.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa M.",
      location: "The Plains, OH",
      rating: 5,
      text: "My passport expired the week before our family trip to the Caribbean. Living in a rural area, I worried about access. Fast Passport Center made it so easy — everything online and shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Mark S.",
      location: "Albany, OH",
      rating: 5,
      text: "Business trip to London came up with only 5 days notice. They got me a passport in 4 business days. Professional, thorough, and I never had to leave southeastern Ohio.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "athens-oh-1",
      name: "Athens Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "77 E State St",
      city: "Athens",
      state: "OH",
      zip: "45701",
      phone: "(740) 592-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Athens, Uptown district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main facility near Ohio University campus. High volume during semester breaks — appointments strongly recommended. Serves all of Athens County.",
      icon: "ri-mail-line",
    },
    {
      id: "athens-oh-2",
      name: "Nelsonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "38 W Washington St",
      city: "Nelsonville",
      state: "OH",
      zip: "45764",
      phone: "(740) 753-1221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Nelsonville, 15 miles north of Athens",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Athens County and Hocking County residents. Less crowded than Athens. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "athens-oh-3",
      name: "The Plains Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "33 S Plains Rd",
      city: "The Plains",
      state: "OH",
      zip: "45780",
      phone: "(740) 797-4621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "The Plains, 8 miles north of Athens",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Athens County communities. Smaller facility — call ahead for availability.",
      icon: "ri-mail-line",
    },
    {
      id: "athens-oh-4",
      name: "Albany Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 W Main St",
      city: "Albany",
      state: "OH",
      zip: "45710",
      phone: "(740) 698-2121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Albany, 20 miles west of Athens",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Athens County and eastern Meigs County. Rural location with limited hours.",
      icon: "ri-mail-line",
    },
    {
      id: "athens-oh-5",
      name: "Athens County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "1 S Court St",
      city: "Athens",
      state: "OH",
      zip: "45701",
      phone: "(740) 592-3240",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Athens County Courthouse",
      website: "https://www.athenscountyohio.gov/",
      websiteLabel: "Athens County Government",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "athens-oh-6",
      name: "Pomeroy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Main St",
      city: "Pomeroy",
      state: "OH",
      zip: "45769",
      phone: "(740) 992-2121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pomeroy, 30 miles south of Athens",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Athens County and Meigs County. Ohio River town location.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 7 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Athens photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Athens County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Athens applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Athens County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Athens travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Athens." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Athens address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Athens before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Athens for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Athens?", a: "Fast Passport Center offers fast passport renewal in Athens in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "I'm an Ohio University student — can you help me get a passport?", a: "Absolutely. Fast Passport Center regularly serves Ohio University students and faculty preparing for study abroad, research trips, and international travel. We understand the unique needs of college students and offer flexible processing options. We serve all OU students whether they live on campus or off-campus in Athens." },
    { q: "Can I get a same-day passport appointment near Athens?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 7 hours from Athens — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Athens County residents." },
    { q: "Can I expedite a child passport in Athens?", a: "Yes. Fast Passport Center expedites child passports in Athens for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Athens County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Athens with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "What is the closest passport agency to Athens?", a: "The nearest regional passport agency to Athens is the Chicago Passport Agency, approximately 400 miles away. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Athens without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Athens", address: "859 E State St, Athens, OH 45701", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Athens", address: "10 Columbus Rd, Athens, OH 45701", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Athens", address: "929 E State St, Athens, OH 45701", hours: "Mon-Sun: 6AM-11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Nelsonville", address: "10 Hocking St, Nelsonville, OH 45764", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Logan", address: "1293 W Main St, Logan, OH 43138", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — The Plains", address: "33 S Plains Rd, The Plains, OH 45780", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Chillicothe", address: "85 River Trace Ln, Chillicothe, OH 45601", hours: "Mon-Sun: 6AM-11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Albany", address: "150 W Main St, Albany, OH 45710", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Athens County BMV — Athens",
      address: "1400 W State St, Athens, OH 45701",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Hocking County BMV — Logan",
      address: "1296 W Main St, Logan, OH 43138",
      hours: "Mon-Fri: 8AM-4:30PM",
      note: "Alternative for Hocking County and northern Athens County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Meigs County BMV — Pomeroy",
      address: "418 W Main St, Pomeroy, OH 45769",
      hours: "Mon-Fri: 8AM-4:30PM",
      note: "Serves Meigs County and southern Athens County.",
      featured: false,
    },
    {
      name: "AAA — Athens",
      address: "1000 E State St, Athens, OH 45701",
      hours: "Mon-Fri: 8AM-5:30PM, Sat: 9AM-12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "75 miles northwest of Athens",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Closest major airport to Athens. Direct flights to major hubs including Atlanta, Chicago, and Charlotte. Best option for Athens County and Ohio University travelers.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: true,
    },
    {
      code: "CRW",
      name: "Yeager Airport (Charleston, WV)",
      distance: "85 miles south of Athens",
      address: "100 Airport Rd, Charleston, WV 25311",
      note: "Alternative for southeastern Ohio residents. Smaller hub with connections to major cities.",
      flightUrl: "https://www.yeagerairport.com/",
      flightLabel: "Yeager Airport",
      featured: false,
    },
    {
      code: "HTS",
      name: "Tri-State Airport (Huntington, WV)",
      distance: "70 miles southwest of Athens",
      address: "1449 Airport Rd, Huntington, WV 25704",
      note: "Alternative for western Athens County residents. Regional airport with connections to Charlotte and Atlanta.",
      flightUrl: "https://www.tristateairport.com/",
      flightLabel: "Tri-State Airport",
      featured: false,
    },
  ],
};